<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <br />
      <v-flex xs12 sm12 md12>
        <v-toolbar card class="primary white--text">
          <router-link
            v-if="$route.params.customerId"
            :to="{
              name: 'BuyersInfo',
              params: { buyerId: $route.params.customerId },
            }"
          >
            <v-btn outlined="primary" @click="dialog = false">
              <v-icon class="primary--text">keyboard_backspace</v-icon>
            </v-btn>
          </router-link>
          <v-flex xs12 sm6 md2>
            <h3 class="strong white--text font-weight-light headline">
              {{ this.currentUser.name }}
            </h3>
          </v-flex>
          <!-- <v-flex xs12 sm6 md3>
            <v-select
              class="select-firm"
              dense
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6 md2>
          </v-flex>  
          
          <v-flex xs12 sm3 md2>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerFrom"
              :nudge-right="40"
              class="ist-datepicker"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerTo"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              class="ist-datepicker"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-spacer/>  
          <v-flex xs12 sm6 md1>
             <v-btn outlined>
               <v-icon class="primary white--text">
                 print
               </v-icon>
             </v-btn> 
          </v-flex> -->
          <v-spacer />
          <router-link
            v-if="$route.params.customerId"
            :to="{
              name: 'BuyersInfo',
              params: { buyerId: $route.params.customerId },
            }"
          >
            <v-btn outlined @click="dialog = false">
              <v-icon class="primary--text">close</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
      </v-flex>

      <v-flex xs12 sm6 md6>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center"
            >Advance Deposit</v-toolbar-title
          >

          <v-spacer></v-spacer>

          <v-card-actions class="justify-center">
            <v-btn
              outlined
              @click="addDiposit('Advance')"
              class="primary--text"
            >
              <v-icon>add</v-icon>
              &nbsp; ADVANCED DEPOSIT
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="AdvancedDepositeHeader"
          :items="advanceDepositListByCustomer"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }}</b>
            </td>
            <td>
              <b v-if="props.item['isUserCreated']">{{
                props.item["amount"] || 0 | amount
              }}</b>
              <b v-else></b>
            </td>
            <td>
              <b v-if="!props.item['isUserCreated']">{{
                props.item["settledAmount"] || 0 | amount
              }}</b>
              <b v-else></b>
            </td>
            <td>
              <b>{{ props.item["paymentType"] }}</b>
            </td>
            <td v-if="props.item['isUserCreated']">
              <v-btn icon class="mx-0" @click="editDeposite(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td v-if="props.item['isUserCreated']">
              <v-btn icon class="mx-0" @click="deleteDeposit(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <b>{{ props.item["remark"] }}</b>
            </td>
            <td>
              <b>{{ getFirmName(props.item["firm"]) }}</b>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 sm6 md6>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center"
            >Security Deposit</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn
              outlined
              @click="addDiposit('Security')"
              class="primary--text"
            >
              <v-icon>add</v-icon>
              &nbsp; SECURITY DEPOSIT
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="SecurityDepositeHeader"
          :items="securityDepositListByCustomer"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }}</b>
            </td>
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b v-if="props.item['isUserCreated']">{{
                props.item["amount"] || 0 | amount
              }}</b>
              <b v-else></b>
            </td>
            <td>
              <b v-if="!props.item['isUserCreated']">{{
                props.item["settledAmount"] || 0 | amount
              }}</b>
              <b v-else></b>
            </td>
            <td>
              <b>{{ props.item["mortgage"] }}</b>
            </td>

            <td>
              <v-btn
                v-if="props.item['isUserCreated']"
                icon
                class="mx-0"
                @click="editDeposite(props.item)"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                v-if="props.item['isUserCreated']"
                icon
                class="mx-0"
                @click="deleteDeposit(props.item)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <b>{{ getFirmName(props.item["firm"]) }}</b>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 sm6 md6>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">{{
            isBuyer ? "Note Order" : "Place Order"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn
              outlined
              @click="
                isBuyer ? addDiposit('Send Order') : addDiposit('Place Order')
              "
              class="primary--text"
            >
              <v-icon>add</v-icon>
              &nbsp; NEW {{ isBuyer ? "Order" : "Order" }}
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="orderHeader"
          :items="isBuyer ? sendOrderListByCustomer : placeOrderListByCustomer"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ props.item[".key"] }}</b>
            </td>
            <td>
              <b>{{ props.item["quantity"] }}</b>
            </td>
            <td>
              <b>{{ props.item["product"] }}</b>
            </td>
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editDeposite(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteDeposit(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 sm6 md6>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center"
            >Opening Balance</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn
              outlined
              @click="addDiposit('Opening Balance')"
              class="primary--text"
            >
              <v-icon>add</v-icon>
              &nbsp; OPENING BALANCE
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="OpeningBalanceHeader"
          :items="openingBalanceListByCustomer"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }}</b>
            </td>
            <td>
              <b v-if="props.item['isUserCreated']">{{
                props.item["amount"] || 0 | amount
              }}</b>
              <b v-else></b>
            </td>
            <td>
              <b v-if="!props.item['isUserCreated']">{{
                props.item["settledAmount"] || 0 | amount
              }}</b>
              <b v-else></b>
            </td>
            <td>
              <b v-if="props.item.interest">{{ props.item["interest"] }}</b>
            </td>
            <td>
              <b v-if="props.item.interest">{{
                getInterest(props.item) > 0 ? getInterest(props.item) : 0
              }}</b>
            </td>

            <td>
              <v-btn icon class="mx-0" @click="editDeposite(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteDeposit(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <b>{{ getFirmName(props.item["firm"]) }}</b>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>

      <!-- When Loan is Given -->
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">Loan Given</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn
              outlined
              @click="addDiposit('LoanGiven')"
              class="primary--text"
            >
              <v-icon>add</v-icon>
              &nbsp; NEW LOAN
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="LoanGivenHeader"
          :items="givenLoanListByCustomer"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <template v-if="!props.item.loanTransaction">
              <tr>
                <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
                <td>
                  <v-btn
                    :disabled="props.item.status == 'paid'"
                    outlined
                    @click="addDiposit('LoanTaken', props.item)"
                    class="primary--text"
                  >
                    PAY
                  </v-btn>
                </td>
                <td>
                  <b>{{
                    new Date(props.item.date).toLocaleDateString("en-GB")
                  }}</b>
                </td>
                
                <td>
                  <b>{{ props.item["amount"] || 0 | amount }}</b>
                </td>

                <td>
                  <b>{{ props.item["interest"] }}</b>
                </td>
                <td>
                  <b>{{
                    getInterest(props.item) > 0 ? getInterest(props.item) : 0
                  }}</b>
                </td>
                <td>
                  <b>{{ getDuration(props.item) }}</b>
                </td>
                <td>
                  <b>{{ props.item["paidAmount"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["paidInterest"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["paymentType"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["status"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["remark"] }}</b>
                </td>
                <td>
                <v-btn icon class="mx-0" @click="printLoanReceipt(props.item)">
                  <v-icon color="pink">print</v-icon>
                </v-btn>
              </td>
                <td>
                  <v-btn 
                    :disabled="props.item.status == 'paid'"
                    icon class="mx-0" @click="editDeposite(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn 
                    :disabled="props.item.status == 'paid'"
                    icon class="mx-0" @click="deleteDeposit(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
                <td>
                  <b>{{
                    new Date(props.item.interestDate).toLocaleDateString(
                      "en-GB"
                    )
                  }}</b>
                </td>
                <td>
                  <b>{{ props.item["transferType"] }}</b>
                </td>
                <td>
                  <b>{{ getFirmName(props.item["firm"]) }}</b>
                </td>
              </tr>
              <template v-for="loan in props.item.transactions">
                <tr
                  v-if="loan['.key']"
                  :key="loan['.key'] + 'roww'"
                  class="loan-transactions"
                >
                  <!-- <td :key="loan['.key'] + 'k'">
                    <b>{{ loan[".key"] }}</b>
                  </td> -->
                  
                  <td :key="loan['.key'] + 'key'"></td>
                  <td :key="loan['.key'] + 'date'">
                    <b>{{ new Date(loan.date).toLocaleDateString("en-GB") }}</b>
                  </td>
                  <td :key="loan['.key'] + 'a'"></td>
                  <td :key="loan['.key'] + 'int'"></td>
                  <td :key="loan['.key'] + 'getint'"></td>
                  <td :key="loan['.key'] + 'dur'"></td>
                  <td :key="loan['.key'] + 'paidAmount'">
                    <b>{{ loan["paidAmount"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'paidInterest'">
                    <b>{{ loan["paidInterest"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'paytype'">
                    <b>{{ loan["paymentType"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'PT'">
                    <b>{{ loan["loanPaymentType"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'firm'"></td>                  
                  <td :key="loan['.key'] + 'interest'"></td>                  
                  <td :key="loan['.key'] + 'edit'"></td>
                  <td :key="loan['.key'] + 'delete'"></td>
                  <td :key="loan['.key'] + 'trans'"></td>
                  <td :key="loan['.key'] + 'pay'"></td>
                </tr>
              </template>
            </template>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>

      <!-- when Loan is Taken -->
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">Loan Taken</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn
              outlined
              @click="addDiposit('LoanTaken')"
              class="primary--text"
            >
              <v-icon>add</v-icon>
              &nbsp; NEW LOAN
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="LoanTakenHeader"
          :items="takenLoanListByCustomer"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <template v-if="!props.item.loanTransaction">
              <tr>
                <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
                <td>
                  <v-btn
                    :disabled="props.item.status == 'paid'"
                    outlined
                    @click="addDiposit('LoanTaken', props.item)"
                    class="primary--text"
                  >
                    PAY
                  </v-btn>
                </td>
                <td>
                  <b>{{
                    new Date(props.item.date).toLocaleDateString("en-GB")
                  }}</b>
                </td>
                <td>
                  <b>{{
                    new Date(props.item.interestDate).toLocaleDateString(
                      "en-GB"
                    )
                  }}</b>
                </td>
                <td>
                  <b>{{ props.item["amount"] || 0 | amount }}</b>
                </td>
                <td>
                  <b>{{ props.item["interest"] }}</b>
                </td>
                <td>
                  <b>{{
                    getInterest(props.item) > 0 ? getInterest(props.item) : 0
                  }}</b>
                </td>
                <td>
                  <b>{{ getDuration(props.item) }}</b>
                </td>
                <td>
                  <b>{{ props.item["paidAmount"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["paidInterest"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["paymentType"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["transferType"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["status"] }}</b>
                </td>
                <td>
                  <b>{{ props.item["remark"] }}</b>
                </td>
                <td>
                  <v-btn icon class="mx-0" @click="editDeposite(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn icon class="mx-0" @click="deleteDeposit(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
                <td>
                  <b>{{ getFirmName(props.item["firm"]) }}</b>
                </td>
              </tr>
              <template v-for="loan in props.item.transactions">
                <tr
                  v-if="loan['.key']"
                  :key="loan['.key'] + 'roww'"
                  class="loan-transactions"
                >
                  <td :key="loan['.key'] + 'k'">
                    <b>{{ loan[".key"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'a'"></td>
                  <td :key="loan['.key'] + 'paytype'">
                    <b>{{ loan["paymentType"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'trans'"></td>
                  <td :key="loan['.key'] + 'int'"></td>
                  <td :key="loan['.key'] + 'getint'"></td>
                  <td :key="loan['.key'] + 'dur'"></td>
                  <td :key="loan['.key'] + 'paidAmount'">
                    <b>{{ loan["paidAmount"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'paidInterest'">
                    <b>{{ loan["paidInterest"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'firm'"></td>
                  <td :key="loan['.key'] + 'date'">
                    <b>{{ new Date(loan.date).toLocaleDateString("en-GB") }}</b>
                  </td>
                  <td :key="loan['.key'] + 'interest'"></td>
                  <td :key="loan['.key'] + 'PT'">
                    <b>{{ loan["loanPaymentType"] }}</b>
                  </td>
                  <td :key="loan['.key'] + 'edit'"></td>
                  <td :key="loan['.key'] + 'delete'"></td>
                  <td :key="loan['.key'] + 'pay'"></td>
                </tr>
              </template>
            </template>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addDipositDialog" persistent max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-btn icon dark @click="addDipositDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline"
            >{{ currentDeposite.type }} Deposit Details</span
          >
          <v-spacer></v-spacer>
          <v-switch
            class="customer-deposite"
            v-if="
              !loanPayment &&
              (currentDeposite.type == 'Advance' ||
                currentDeposite.type == 'LoanGiven' ||
                currentDeposite.type == 'LoanTaken' ||
                currentDeposite.type == 'Security')
            "
            style="margin-top: 13px"
            v-model="isOpeningBalance"
            @change="openingBalanceSwitcherChange()"
            :label="`Enter as opening Balance: ${
              isOpeningBalance ? 'Yes' : 'No'
            }`"
          ></v-switch>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                sm12
                md12
                v-if="
                  (currentDeposite.type == 'LoanTaken' ||
                    currentDeposite.type == 'LoanGiven' ||
                    currentDeposite.type == 'Opening Balance') &&
                  loanPayment
                "
              >
                <v-radio-group
                  :key="'deposite-amount-total'"
                  v-model="loanPaymentType"
                  @change="calculateAmounts()"
                  row
                >
                  <v-radio :label="`Pay Custom`" :value="`custom`"></v-radio>
                  <v-radio :label="`Pay Interest`" :value="`interest`"></v-radio>
                  <v-radio :label="`Pay Full`" :value="`full`"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                v-if="
                  currentDeposite.type != 'Send Order' &&
                  currentDeposite.type != 'Place Order'
                "
              >
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  :readonly="isSummary"
                  v-model="currentDeposite.firm"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 class="date-container">
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="currentDeposite.date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                    class="deposite-date"
                  ></v-text-field>
                  <v-date-picker
                    v-model="currentDeposite.date"
                    @input="datepicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="currentDeposite.type == 'Security'">
                <v-text-field
                  type="text"
                  v-model="currentDeposite.mortgage"
                  label="Mortgage"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                v-if="
                  currentDeposite.type == 'Advance' ||
                  currentDeposite.type == 'LoanGiven' ||
                  currentDeposite.type == 'LoanTaken' ||
                  (currentDeposite.type == 'Opening Balance' && loanPayment)
                "
              >
                <v-select
                  dense
                  :items="[
                    {
                      text: 'Cash',
                      value: 'Cash',
                    },
                    {
                      text: 'Bank Account',
                      value: 'Bank Account',
                    },
                    {
                      text: 'Cash & Bank Account',
                      value: 'CashAndBank Account',
                    },
                  ]"
                  label="Select Payment Type"
                  v-model="currentDeposite.paymentType"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
                v-if="
                  currentDeposite.type == 'LoanTaken' ||
                  currentDeposite.type == 'LoanGiven' ||
                  (currentDeposite.type == 'Opening Balance' &&
                    previousType != 'Advance' &&
                    previousType != 'Security')
                "
              >
                <v-text-field
                  type="number"
                  v-model="currentDeposite.interest"
                  label="Interest Rate"
                  :disabled="loanPayment"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="
                  !loanPayment &&
                  (currentDeposite.type == 'Security' ||
                    currentDeposite.type == 'Advance' ||
                    currentDeposite.type == 'Opening Balance' ||
                    currentDeposite.type == 'LoanTaken' ||
                    currentDeposite.type == 'LoanGiven')
                "
              >
                <v-text-field
                  type="number"
                  v-model="currentDeposite.amount"
                  :label="loanPayment ? 'Principal Amount' : 'Amount'"
                  :hint="hintText"
                  :disabled="loanPayment"
                ></v-text-field>
              </v-flex>
              <v-textarea
                  background-color="grey darken-1"
                  color="black"
                  type="text"
                  v-model="currentDeposite.remark"
                  label="Remark"
                  :disabled="loanPayment"
                ></v-textarea>
              <v-flex
                xs12
                sm6
                md6
                v-if="
                  currentDeposite.type == 'Send Order' ||
                  currentDeposite.type == 'Place Order'
                "
              >
                <v-text-field
                  type="number"
                  v-model="currentDeposite.quantity"
                  label="Quantity"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
                v-if="
                  (currentDeposite.type == 'LoanTaken' ||
                    currentDeposite.type == 'LoanGiven') &&
                  loanPayment
                "
              >
                <v-text-field
                  type="number"
                  :value="currentDeposite.interestAmount"
                  label="Interest Amount"
                  :hint="hintText"
                  :disabled="loanPayment"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
                v-if="
                  (currentDeposite.type == 'LoanTaken' ||
                    currentDeposite.type == 'LoanGiven') &&
                  loanPayment
                "
              >
                <v-text-field 
                  type="number"
                  :value="currentDeposite.roundOffAmount"
                  label="Round Off"
                  :disabled="loanPayment"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
                v-if="
                  (currentDeposite.type == 'LoanTaken' ||
                    currentDeposite.type == 'LoanGiven') &&
                  loanPayment
                "
              >
                <v-text-field
                  type="number"
                  :value="
                    Number.parseFloat(currentDeposite.interestAmount) +
                    Number.parseFloat(currentDeposite.amount) +
                    Number.parseFloat(currentDeposite.roundOffAmount) -
                    Number.parseFloat(currentDeposite.paidAmount)
                  "
                  label="Total Amount"
                  :hint="hintText"
                  :disabled="loanPayment"
                ></v-text-field>
              </v-flex>

              
              <v-flex
                xs12
                sm6
                md6
                v-if="
                  currentDeposite.type == 'Send Order' ||
                  currentDeposite.type == 'Place Order'
                "
              >
                <v-select
                  v-model="currentDeposite.product"
                  :items="productsByBrand"
                  item-text="name"
                  label="Product"
                />
              </v-flex>
              <v-flex v-if="loanPayment || currentDeposite.type == 'Advance' || currentDeposite.type == 'LoanTaken' || currentDeposite.type == 'LoanGiven'" xs12 sm6 md6>
                <v-select
                  dense
                  :items="banksByFirms"
                  v-if="
                    ['Bank Account', 'CashAndBank Account'].includes(
                      currentDeposite.paymentType
                    )
                  "
                  label="Select Bank"
                  v-model="currentDeposite.bank"
                  flat 
                  clearable
                  item-text="bankName"
                  return-object
                >
                <template slot="selection" slot-scope="data">
                  {{ data.item.account.accountnumber }}
                  {{data.item.account.bankName ? ' | '+ data.item.account.bankName : '' }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.account.accountnumber}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }`
                        " />
                    </v-list-tile-content>
                </template>
              </v-select>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="
                  (currentDeposite.type == 'LoanGiven' ||
                    currentDeposite.type == 'LoanTaken' ||
                     currentDeposite.type == 'Advance' || 
                    currentDeposite.type == 'Opening Balance') &&
                  currentDeposite.paymentType != 'Cash' &&
                  currentDeposite.paymentType != ''
                "
              >
                <v-select
                  dense
                  :items="[
                    {
                      text: 'Cheque',
                      value: 'Cheque',
                    },
                    {
                      text: 'NEFT',
                      value: 'NEFT',
                    },
                    {
                      text: 'RTGS',
                      value: 'RTGS',
                    },
                    {
                      text: 'IMPS',
                      value: 'IMPS',
                    },
                  ]"
                  label="Select Transfer type"
                  v-model="currentDeposite.transferType"
                ></v-select>
              </v-flex>
              <v-flex v-if="loanPayment || currentDeposite.type == 'Advance'" xs6 sm6 md6 style="padding-top: 14px">
                <v-text-field
                  v-model="currentDeposite.amountFromCash"
                  :key="'cus-depo-amt-cash'"
                  type="number"
                  label="Amount from Cash"
                  :hint="hintText"
                  v-if="
                    ['Cash', 'CashAndBank Account'].includes(
                      currentDeposite.paymentType
                    )
                  "
                ></v-text-field>
              </v-flex>
              <v-flex v-if="loanPayment || currentDeposite.type == 'Advance'" xs6 sm6 md6 style="padding-top: 14px">
                <v-text-field
                  v-model="currentDeposite.amountFromBank"
                  :key="'cus-depo-amt-bank'"
                  v-if="
                    ['Bank Account', 'CashAndBank Account'].includes(
                      currentDeposite.paymentType
                    )
                  "
                  type="number"
                  :hint="hintText"
                  label="Amount from Bank"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!loanPayment">
          <v-btn
            color="blue darken-1"
            @click="backToPrevious()"
            flat
            v-if="previousType"
            >Back</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="saveDiposit"
            flat
            v-if="!currentDeposite['.key']"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            @click="updateDeposit"
            flat
            v-if="!!currentDeposite['.key']"
            >Update</v-btn
          >
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="payLoan()" flat>Pay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="passwordDialog" width="800" persistent>
        <v-card>
          <v-card-title class="headline primary--text" primary-title>
            Enter the password
            <v-spacer></v-spacer>
            <v-btn icon dark class="primary" @click="passwordDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
             <v-text-field
              v-model="password"
              type="password"
              label="Password"
              autocomplete="false"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
             <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteFromDialog()">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>
<style>
.customer-deposite .theme--light.v-label {
  color: white;
}

.customer-deposite .v-input--switch__track {
  color: rgba(255, 255, 255, 0.38);
}
</style>
<script>
import { createNamespacedHelpers } from "vuex";
import { loanReceiptPDF } from '../../../utils/LoanReceipt';
import { digitsToWords } from '../../../utils/digitsToWords.js'
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  props: {
    isSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      addDipositDialog: false,
      defaultFirm: null,
      isOpeningBalance: false,
      loanPayment: false,
      previousType: null,
      hintText : null,
      password:null,
      passwordDialog : false,
      currentPasswordReference : null,
      currentPasswordMethod : null,
      currentDeposite: {
        amount: "",
        paymentType: "",
        mortgage: "",
        product: "",
        type: "",
        firm: "",
        quantity: 0,
        rate: 0,
        transferType: "",
        date: null,
        paid: null,
        amountFromCash: 0,
        amountFromBank: 0,
        bank: null,
        interest: 0,
      },
      currentUser: {},
      loanPaymentType: null,
      loanToPay: null,
      datepicker: null,
      depositList: [],
      AdvancedDepositeHeader: [
        // { text: "Deposit- ID", value: "deposit - ID" },
        { text: "Date", value: "date" },
        { text: "Debit", value: "amount" },
        { text: "Credit", value: "amount" },
        { text: "Payment Type", value: "type" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Remark", value: "remark" },
        { text: "Firm", value: "quantity" },
      ],
      SecurityDepositeHeader: [
        { text: "Date", value: "date" },
        // { text: "Deposit- ID", value: "deposit - ID" },
        { text: "Debit", value: "amount" },
        { text: "Credit", value: "amount" },
        { text: "Mortgage", value: "Mortgage" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Firm", value: "quantity" },
      ],
      OpeningBalanceHeader: [
        // { text: "Deposit- ID", value: "deposit - ID" },
        { text: "Date", value: "date" },
        { text: "Debit", value: "amount" },
        { text: "Credit", value: "amount" },
        { text: "Interest Rate", value: "rate" },
        { text: "Interest Amount", value: "amount" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Firm", value: "name" },
      ],
      LoanTakenHeader: [
        // { text: "Deposit- ID", value: "deposit - ID" },
        { text: "Pay", value: "Pay" },
        { text: "Date", value: "date" },
        { text: "Amount", value: "amount" },
        { text: "Interest Rate", value: "rate" },
        { text: "Interest Amount", value: "interest" },
        { text: "Duration", value: "duration" },
        { text: "Paid Amount", value: "amount" },
        { text: "Paid Interest", value: "amount" },
        { text: "Payment Type", value: "paymentType" },
        { text: "Status", value: "status" },
        { text: "Remark", value: "remark" },
        { text: "Print", value: "print" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Interest Date", value: "date" },
        { text: "Transfer Type", value: "transferType" },
        { text: "Firm", value: "name" },
      ],
      LoanGivenHeader: [
        // { text: "Deposit- ID", value: "deposit - ID" },
        { text: "Pay", value: "Pay" },
        { text: "Date", value: "date" },
        { text: "Amount", value: "amount" },
        { text: "Interest Rate", value: "rate" },
        { text: "Interest Amount", value: "interest" },
        { text: "Duration", value: "duration" },
        { text: "Paid Amount", value: "amount" },
        { text: "Paid Interest", value: "amount" },
        { text: "Payment Type", value: "paymentType" },
        { text: "Status", value: "status" },
        { text: "Remark", value: "remark" },
        { text: "Print", value: "print" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Interest Date", value: "date" },
        { text: "Transfer Type", value: "transferType" },
        { text: "Firm", value: "name" },
      ],
      orderHeader: [
        { text: "Order- ID", value: "deposit - ID" },
        { text: "Quantity", value: "quantity" },
        { text: "Product", value: "product" },
        { text: "Date", value: "quantity" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
      ],
    };
  },
  mounted() {
    this.getCurrentUser();
  },
  created() {
    this.$bindAsArray(
      "customerDeposit",
      this.$root.$firebaseRefs.customerDeposit
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsObject(
        "buyerById",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "sellerById",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "firmById",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "firms",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "bankById",
        this.$root.$firebaseRefs.account
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "banks",
        this.$root.$firebaseRefs.account
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray(
      "firmSettings",
      this.$root.$firebaseRefs.firmSettings
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  watch: {
    "currentDeposite.date": {
      handler(newVal, oldVal) {
        if (this.loanPayment) {
          let dayDiff = this.dayDiff(
            new Date(this.loanToPay.interestDate),
            new Date(this.currentDeposite.date)
          );
          // console.log(dayDiff)
          this.currentDeposite.interestAmount = this.calculateInterest(
            this.loanToPay.amount,
            this.loanToPay.interest,
            dayDiff
          );
          let total =
            Number.parseFloat(this.currentDeposite.interestAmount) +
            Number.parseFloat(this.currentDeposite.amount);
          let newtotal = Math.round(Number.parseFloat(total));
          this.currentDeposite.roundOffAmount = Number.parseFloat(
            newtotal - total
          ).toFixed(2);
          this.calculateAmounts();
        }
      },
      deep: true,
    },
    "currentDeposite.amount" : {
      handler(){
        this.hintText = this.currentDeposite.amount ? _.startCase(digitsToWords(Number.parseFloat(this.currentDeposite.amount))) : null
      },
      deep : true
    },
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapBuyerGetters(["selectedBuyer"]),
    depositListByBrand() {
      return this.depositList.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end
      );
    },
    banksByFirms() {
      return this.banks.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          item["firm"] === this.currentDeposite.firm
        );
      })
      .map(item => {
        return {
          account: item,
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },
    // banksByFirms() {
    //   return this.banks
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand &&
    //         item["firm"] === this.currentDeposite['firm']
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         account: item,
    //         text: item["bankName"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.defaultFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    productsByBrand() {
      return this.products.filter(
        (item) => item["brand"] === this.selectedBrand
      );
    },
    advanceDepositListByCustomer() {
      return this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          (item["type"] === "Advance" ||
            (item["parentType"] === "Advance" &&
              item["type"] === "Opening Balance"))
      );
    },
    openingBalanceListByCustomer() {
      return this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          item["type"] === "Opening Balance" &&
          !item["parentType"]
      );
    },
    givenLoanListByCustomer() {
      let loan = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          (item["type"] === "LoanGiven" ||
            (item["parentType"] === "LoanGiven" &&
              item["type"] === "Opening Balance"))
      );
      loan.map((l, index) => {
        let transactions = loan.filter((item) => item["loanId"] == l[".key"]);
        loan[index]["transactions"] = transactions;
      });
      return loan;
    },
    takenLoanListByCustomer() {
      let loan = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          (item["type"] === "LoanTaken" ||
            (item["parentType"] === "LoanTaken" &&
              item["type"] === "Opening Balance"))
      );
      loan.map((l, index) => {
        let transactions = loan.filter((item) => item["loanId"] == l[".key"]);
        loan[index]["transactions"] = transactions;
      });
      return loan;
    },
    securityDepositListByCustomer() {
      return this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          (item["type"] === "Security" ||
            (item["parentType"] === "Security" &&
              item["type"] === "Opening Balance"))
      );
    },
    sendOrderListByCustomer() {
      return this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          item["type"] === "Send Order"
      );
    },
    isBuyer() {
      let buyer = this.buyerById[this.$route.params.customerId];
      let seller = this.sellerById[this.$route.params.customerId];
      return buyer && Object.keys(buyer).length != 0 ? true : false;
    },
    placeOrderListByCustomer() {
      return this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item.date >= this.finYear.start &&
          item.date <= this.finYear.end &&
          item["type"] === "Place Order"
      );
    },
  },
  methods: {
    calculateAmounts() {
      let total =
        Number.parseFloat(this.currentDeposite.interestAmount) +
        Number.parseFloat(this.currentDeposite.amount) -
        Number.parseFloat(this.currentDeposite.paidAmount);
      let newtotal = Math.round(Number.parseFloat(total));
      switch (this.currentDeposite.paymentType) {
        case "Cash": {
          if (this.loanPaymentType == "full") {
            this.currentDeposite.amountFromCash = Number.parseFloat(newtotal);
            this.currentDeposite.amountFromBank = 0;
          }

          if (this.loanPaymentType == "interest") {
            this.currentDeposite.amountFromCash = Number.parseFloat(
              this.currentDeposite.interestAmount
            );
            this.currentDeposite.amountFromBank = 0;
          }
          break;
        }
        case "Bank Account": {
          if (this.loanPaymentType == "full") {
            this.currentDeposite.amountFromBank = Number.parseFloat(newtotal);
            this.currentDeposite.amountFromCash = 0;
          }

          if (this.loanPaymentType == "interest") {
            this.currentDeposite.amountFromBank = Number.parseFloat(
              this.currentDeposite.interestAmount
            );
            this.currentDeposite.amountFromCash = 0;
          }
          break;
        }
        case "CashAndBank Account": {
          if (this.loanPaymentType == "full") {
            this.currentDeposite.amountFromBank =
              Number.parseFloat(newtotal) / 2;
            this.currentDeposite.amountFromCash =
              Number.parseFloat(newtotal) / 2;
          }

          if (this.loanPaymentType == "interest") {
            this.currentDeposite.amountFromBank =
              Number.parseFloat(this.currentDeposite.interestAmount) / 2;
            this.currentDeposite.amountFromCash =
              Number.parseFloat(this.currentDeposite.interestAmount) / 2;
          }
          break;
        }
      }
    },
    backToPrevious() {
      this.isOpeningBalance = false;
      this.openingBalanceSwitcherChange();
    },
    getDuration(inv) {
      const date1 = new Date(inv.interestDate);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays + " Days";
    },

    // Start of New Development 03/06/21
    async printLoanReceipt(item){
      // console.log(item)
      let termsAndConditions = this.getTermsAndConditions(item);
      if(!item.multiFirm){
        await loanReceiptPDF({
            firm: Object.assign({},this.firms.filter(item1 => item1['.key'] == item.firm)[0]),
            customer: this.currentUser,
            terms : termsAndConditions[0],
            payment : item
      }).then((doc) => {
          pdfMake.createPdf(doc).download(this.currentUser.name + "_Receipt");
      });
      }
    },
    getTermsAndConditions(invoiceData) {
      let termsAndConditions = this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === invoiceData.firm
      );
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.bankById[bankId];
            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if (!item) {
        return "";
      }
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    // end of New Development 03/06/21
    openingBalanceSwitcherChange() {
      if (this.isOpeningBalance) {
        this.previousType = this.currentDeposite.type;
        this.addDiposit("Opening Balance");
      } else {
        this.addDiposit(this.previousType);
        this.previousType = null;
      }
    },
    saveDiposit() {
      this.currentDeposite.brand = this.selectedBrand;
      this.customer = this.$route.params.customerId;
      if (
        [
          "Security",
          "Opening Balance",
          "Advance",
          "LoanGiven",
          "LoanTaken",
        ].includes(this.currentDeposite.type)
      ) {
        this.currentDeposite["isUserCreated"] = true;
        this.currentDeposite["remainingAmount"] = this.currentDeposite[
          "amount"
        ];
      }
      if (this.isOpeningBalance && this.previousType != null) {
        this.currentDeposite["parentType"] = this.previousType;
      }
      if (
        ["LoanGiven", "LoanTaken", "Opening Balance"].includes(
          this.currentDeposite.type
        )
      ) {
        this.currentDeposite["status"] = "due";
        this.currentDeposite["interestDate"] = new Date(
          this.currentDeposite.date
        ).getTime();
        this.currentDeposite["paidAmount"] = 0;
      } else {
        delete this.currentDeposite["interest"];
      }
      this.currentDeposite.date = new Date(this.currentDeposite.date).getTime();
      this.currentDeposite["isBuyer"] = this.isBuyer;
      if (this.currentDeposite["bank"]) {
        this.currentDeposite["bank"] = this.currentDeposite["bank"]["value"] || this.currentDeposite["bank"][".key"];
      }
      this.$root.$firebaseRefs.customerDeposit.push(this.currentDeposite);
      if (
        ["Security", "Advance", "LoanGiven", "LoanTaken"].includes(
          this.currentDeposite.type
        )
      ) {
        this.handleTransaction();
      }
      //this.addRemainingBalance();
      this.addDipositDialog = false;
    },
    payLoan() {
      this.currentDeposite.brand = this.selectedBrand;
      this.customer = this.$route.params.customerId;
      switch (this.loanPaymentType) {
        case "custom": {
          this.currentDeposite.status = "partial";
          this.currentDeposite["paidAmount"] =
            Number.parseFloat(this.currentDeposite.amountFromCash) +
            Number.parseFloat(this.currentDeposite.amountFromBank);
          this.currentDeposite.paidInterest = this.loanToPay.paidInterest
            ? this.loanToPay.paidInterest
            : 0;
          break;
        }
        case "interest": {
          this.currentDeposite.status = "partial";
          this.currentDeposite.paidInterest = this.loanToPay.paidInterest
            ? this.loanToPay.paidInterest +
              this.currentDeposite.amountFromCash +
              this.currentDeposite.amountFromBank
            : this.currentDeposite.amountFromCash +
              this.currentDeposite.amountFromBank;
          this.currentDeposite.interestDate = new Date(
            this.currentDeposite.date
          ).getTime();
          this.currentDeposite["paidAmount"] = 0;
          break;
        }
        case "full": {
          this.currentDeposite.status = "paid";
          this.currentDeposite.paidInterest = this.loanToPay.paidInterest
            ? Number.parseFloat(this.loanToPay.paidInterest) +
              Number.parseFloat(this.currentDeposite.interestAmount)
            : Number.parseFloat(this.currentDeposite.interestAmount);
          this.currentDeposite["paidAmount"] =
            this.currentDeposite.amountFromCash +
            this.currentDeposite.amountFromBank;
          // + (this.currentDeposite.paidInterest || 0)
          break;
        }
      }
      this.currentDeposite.date = new Date(this.currentDeposite.date).getTime();
      this.currentDeposite["loanPaymentType"] = this.loanPaymentType;
      if (this.currentDeposite["bank"]) {
        this.currentDeposite["bank"] = this.currentDeposite["bank"][".key"];
      }
      //this.currentDeposite['principalAmount'] = this.currentDeposite['amount'];

      //console.log(JSON.stringify(this.currentDeposite,null,4))
      this.currentDeposite["loanTransaction"] = true;
      this.currentDeposite["loanId"] = this.loanToPay[".key"];
      this.currentDeposite["isBuyer"] = this.isBuyer;
      this.$root.$firebaseRefs.customerDeposit.push(this.currentDeposite);
      this.loanToPay.paidInterest = this.currentDeposite["paidInterest"];
      this.loanToPay.paidAmount = this.currentDeposite["paidAmount"];
      this.loanToPay.status = this.currentDeposite["status"];
      delete this.loanToPay[".key"];
      this.$root.$firebaseRefs.customerDeposit
        .child(this.currentDeposite["loanId"])
        .set(this.loanToPay);
      this.addDipositDialog = false;
      this.handleLoanPayment();
    },
    // addRemainingBalance(){
    //   let advanceDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Advance" &&
    //       !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let advanceDepositTotal = 0;
    //   advanceDeposit.map((inv,index)  => {
    //     advanceDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let openingBalance = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Opening Balance" &&
    //        !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let openingBalanceTotal = 0;
    //   openingBalance.map((inv,index) => {
    //     openingBalanceTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let securityDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Security" &&
    //        !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let securityDepositTotal = 0;
    //   securityDeposit.map((inv,index) => {
    //     securityDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let totalAmount = ((Number.parseFloat(openingBalanceTotal)) - (Number.parseFloat(advanceDepositTotal) + Number.parseFloat(securityDepositTotal)))
    //   if(this.isBuyer) {
    //     let buyer = this.buyerById[this.$route.params.customerId];
    //     if(buyer) {
    //       buyer.remainingAmountFromDeposite = totalAmount
    //       delete buyer['.key']
    //       this.$root.$firebaseRefs.buyer.child(this.$route.params.customerId).set(buyer);
    //     }
    //   } else {
    //     let seller = this.sellerById[this.$route.params.customerId];
    //     if(seller) {
    //       seller.remainingAmountFromDeposite = totalAmount
    //       delete seller['.key']
    //       this.$root.$firebaseRefs.seller.child(this.$route.params.customerId).set(seller);
    //     }
    //   }
    // },
    handleLoanPayment() {
      let LoanType =
        this.currentDeposite.type == "Opening Balance"
          ? this.currentDeposite.parentType
          : this.currentDeposite.type;
      let multiple = LoanType == "LoanGiven" ? 1 : -1;
      if(this.currentDeposite.type == "Advance") {
        multiple = this.currentDeposite.isBuyer ? 1 : -1;
      }
      switch (this.currentDeposite.paymentType) {
        case "Cash": {
          if (this.currentDeposite.amountFromCash) {
            let firm = this.firmById[this.currentDeposite.firm];
            // console.log(JSON.stringify(firm,null,4))
            if (firm) {
              firm.amount =
                Number.parseFloat(firm.amount) +
                multiple *
                  Number.parseFloat(this.currentDeposite.amountFromCash);
              let key = firm[".key"];
              delete firm[".key"];
              this.$root.$firebaseRefs.firm
                .child(this.currentDeposite.firm)
                .set(firm);
            }
          }
          break;
        }
        case "Bank Account": {
          if (this.currentDeposite.amountFromBank) {
            let bank = this.bankById[this.currentDeposite.bank];
            //  console.log(JSON.stringify(bank,null,4))
            if (bank) {
              bank.amount =
                Number.parseFloat(bank.amount) +
                multiple *
                  Number.parseFloat(this.currentDeposite.amountFromBank);
              let key = bank[".key"];
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(this.currentDeposite.bank)
                .set(bank);
            }
          }
          break;
        }
        case "CashAndBank Account": {
          if (
            this.currentDeposite.amountFromCash &&
            this.currentDeposite.amountFromBank
          ) {
            let bank = this.bankById[this.currentDeposite.bank];
            if (bank) {
              bank.amount =
                Number.parseFloat(bank.amount) +
                multiple *
                  Number.parseFloat(this.currentDeposite.amountFromBank);
              let key = bank[".key"];
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(this.currentDeposite.bank)
                .set(bank);
            }
            let firm = this.firmById[this.currentDeposite.firm];
            if (firm) {
              firm.amount =
                Number.parseFloat(firm.amount) +
                multiple *
                  Number.parseFloat(this.currentDeposite.amountFromCash);
              let key = firm[".key"];
              delete firm[".key"];
              this.$root.$firebaseRefs.firm
                .child(this.currentDeposite.firm)
                .set(firm);
            }
          }
          break;
        }
      }
    },
    handleTransaction() {
      let isBuyer = this.isBuyer;
      if (this.currentDeposite.type == "LoanTaken") {
        let firm = this.firmById[this.currentDeposite.firm];
        firm.amount =
          Number.parseFloat(firm.amount) +
          (isBuyer
            ? Number.parseFloat(this.currentDeposite.amount)
            : -Number.parseFloat(this.currentDeposite.amount));
        this.$root.$firebaseRefs.firm
          .child(this.currentDeposite.firm)
          .set(firm);
      } else if (this.currentDeposite.type == "LoanGiven") {
        let firm = this.firmById[this.currentDeposite.firm];
        firm.amount =
          Number.parseFloat(firm.amount) +
          (isBuyer
            ? -Number.parseFloat(this.currentDeposite.amount)
            : Number.parseFloat(this.currentDeposite.amount));
        this.$root.$firebaseRefs.firm
          .child(this.currentDeposite.firm)
          .set(firm);
      } else if(this.currentDeposite.type == "Advance"){
        this.handleLoanPayment();
      }
    },
    getFirmName(firm) {
      return firm ? this.firmById[firm].name : "";
    },
    getCurrentUser() {
      let buyer = this.buyerById[this.selectedBuyer];
      let seller = this.sellerById[this.selectedBuyer];
      this.isUserBuyer = buyer ? true : false;
      this.currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },
    // isBuyer(){
    //   let buyer = this.buyerById[this.$route.params.customerId];
    //   let seller = this.sellerById[this.$route.params.customerId];
    //   return buyer && Object.keys(buyer).length != 0 ? true : false;
    // },
    addDiposit(type, pay) {
      console.log(JSON.stringify(type));
      this.currentDeposite = {
        amount: "",
        paymentType: "",
        mortgage: "",
        product: "",
        // firm : '',
        firm: this.defaultFirm || null,
        type: type,
        quantity: 0,
        transferType: "",
        rate: 0,
        date: new Date().toISOString().substr(0, 10),
        buyerId: this.$route.params.customerId,
        brand: this.selectedBrand,
        paid: null,
      };
      if (pay) {
        this.loanPayment = true;
        this.loanToPay = Object.assign({}, pay);
        this.currentDeposite.firm = this.loanToPay.firm;
        this.currentDeposite.amount = this.loanToPay.amount;
        this.currentDeposite.type = this.loanToPay.type;
        this.currentDeposite.interestDate = this.loanToPay.interestDate;
        this.currentDeposite.paidAmount = this.loanToPay.paidAmount;
        //this.currentDeposite.date = new Date(this.loanToPay.date).toISOString().substr(0, 10);
        if (this.loanToPay.parentType) {
          this.currentDeposite.parentType = this.loanToPay.parentType;
        }
        if (this.loanToPay.interest) {
          this.currentDeposite.interest = this.loanToPay.interest;
          this.loanPaymentType = "full";
          this.currentDeposite.paymentType = "Cash";
          let dayDiff = this.dayDiff(
            new Date(this.loanToPay.interestDate),
            new Date(this.currentDeposite.date)
          );
          this.currentDeposite.interestAmount = this.calculateInterest(
            this.loanToPay.amount,
            this.loanToPay.interest,
            dayDiff
          );
          let total =
            Number.parseFloat(this.currentDeposite.interestAmount) +
            Number.parseFloat(this.currentDeposite.amount) -
            Number.parseFloat(this.currentDeposite.paidAmount);
          let newtotal = Math.round(Number.parseFloat(total));
          //this.currentDeposite.amountFromCash = newtotal;
          this.currentDeposite.roundOffAmount = Number.parseFloat(
            newtotal - total
          ).toFixed(2);
        }
      } else {
        this.loanPayment = false;
        this.loanToPay = null;
      }
      this.addDipositDialog = true;
    },
    dayDiff(dt1, dt2) {
      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
    },
    getInterest(loan) {
      let dayDiff = this.dayDiff(new Date(loan.interestDate), new Date());
      return this.calculateInterest(loan.amount, loan.interest, dayDiff);
    },
    calculateInterest(P, R, N) {
      var interestRate =
        ((Number.parseFloat(P) * Number.parseFloat(R)) / 3000) * N;
      return Number.parseFloat(interestRate).toFixed(2);
    },
    updateDeposit() {
      let key = this.currentDeposite[".key"];
      delete this.currentDeposite[".key"];
      this.currentDeposite.brand = this.selectedBrand;
      this.customer = this.$route.params.customerId;
      this.currentDeposite.date = new Date(this.currentDeposite.date).getTime();
      this.$root.$firebaseRefs.customerDeposit
        .child(key)
        .set(this.currentDeposite);
      this.currentDeposite = {
        amount: "",
        paymentType: "",
        mortgage: "",
        product: "",
        quantity: 0,
        firm: "",
        transferType: "",
        type: "",
        date: new Date().toISOString().substr(0, 10),
        brand: this.selectedBrand,
        buyerId: this.$route.params.customerId,
        paid: null,
      };
      this.addDipositDialog = false;
    },
    editDeposite(deposit) {
      this.currentDeposite = JSON.parse(JSON.stringify(deposit));
      this.currentDeposite.date = new Date(this.currentDeposite.date)
        .toISOString()
        .substr(0, 10);
      this.addDipositDialog = true;
    },
    deleteFromDialog(){
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteDeposit(deposit) {
      let firmSettings = this.firmSettings.find(i => deposit.firm == i['firm']);
      let hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if(hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password")
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog){
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = deposit;
        this.currentPasswordMethod = "deleteDeposit";
      }
      else if (window.confirm("Do you want to Delete ?")) {
         this.passwordDialog = false;
        this.password = null;
        this.$root.$firebaseRefs.customerDeposit
          .child(deposit[".key"])
          .remove();
        //this.addRemainingBalance();
      }
    },
  },
};
</script>
<style scoped>
.loan-transactions {
  background-color: #dedbff;
}
</style>



// WEBPACK FOOTER //
// src/components/Buyers/CustomerDeposit/customerDeposite.vue